import { render, staticRenderFns } from "./comp_ProductPage-MainContainer.vue?vue&type=template&id=702b509d&scoped=true"
import script from "./comp_ProductPage-MainContainer.vue?vue&type=script&lang=js"
export * from "./comp_ProductPage-MainContainer.vue?vue&type=script&lang=js"
import style0 from "./comp_ProductPage-MainContainer.vue?vue&type=style&index=0&id=702b509d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702b509d",
  null
  
)

export default component.exports